import { AbstractRecommendedNotificationParams } from '@pushly/models/lib/structs/journeys'
import { InvalidFieldException } from '@pushly/models/lib/exceptions/invalid-field-exception'
import { MissingFieldException } from '@pushly/models/lib/exceptions/missing-field-exception'
import { extractFriendlyErrorMessage } from '../../../../exceptions/helpers'

export const validateRecommendedNotification = (
    params: AbstractRecommendedNotificationParams,
): [boolean, string] => {
    try {
        params.validate()
    } catch (error) {
        if (error instanceof InvalidFieldException || error instanceof MissingFieldException) {
            const displayError = extractFriendlyErrorMessage(error, {
                fieldNamesMap: {
                    recommendation_source: 'Recommendation Source',
                    recommendation_config: 'Recommendation Configuration',
                    'recommendation_config.*.boosts': 'Recommendation Configuration boost',
                    'recommendation_config.*.boosts.*.value': 'Boost value',
                    'recommendation_config.*.boosts.*.rampUp': 'Boost ramp up',
                    'recommendation_config.*.boosts.*.algorithm': 'Boost algorithm',
                    'recommendation_config.*.filters': 'Filters',
                },
                startWithProperty: true,
            })

            return [false, displayError.message]
        }

        return [false, error instanceof Error ? error.message : 'Validation failed']
    }

    return [true, '']
}
